var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { PaymentPlanStatus } from '@debbie/common/dist/economy/payment-plans';
import { c } from '@debbie/cortex/dist';
import { Checkbox } from '../../';
import FilterGroup from '../FilterGroup';
import FilterOption from '../FilterOption';
const PaymentPlansGroup = (props) => {
    const { caseFilter } = props;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(FilterGroup, { name: lang.caseFilter.paymentPlansGroup },
        React.createElement(FilterOption, { active: !!(caseFilter.paymentPlansStatuses &&
                caseFilter.paymentPlansStatuses.length), header: lang.caseFilter.paymentPlanStatuses, onDeactivate: () => c.insights.clearFilter('paymentPlansStatuses') },
            React.createElement(Select, { value: (caseFilter.paymentPlansStatuses || []).map((paymentPlanStatus) => ({
                    label: lang.paymentPlans[paymentPlanStatus],
                    value: paymentPlanStatus,
                })), isMulti: true, placeholder: lang.caseFilter.selectPaymentPlanStatus, classNamePrefix: "select", options: Object.entries(PaymentPlanStatus).map((entry) => ({
                    label: lang.paymentPlans[entry[1]],
                    value: entry[1],
                })), onChange: (val) => __awaiter(void 0, void 0, void 0, function* () {
                    const selected = val ? val.map((v) => v.value) : [];
                    c.insights.updateFilter({
                        paymentPlansStatuses: selected,
                    });
                }) })),
        React.createElement(FilterOption, { active: typeof caseFilter.isNotHavingTheAbovePaymentPlansStatuses ===
                'boolean', header: lang.caseFilter.paymentPlanIsNotHavingStatuses, onDeactivate: () => c.insights.clearFilter('isNotHavingTheAbovePaymentPlansStatuses') },
            React.createElement(Checkbox, { style: { marginBottom: '0' }, checked: caseFilter.isNotHavingTheAbovePaymentPlansStatuses, onChange: (e) => {
                    if (e.target.checked) {
                        c.insights.updateFilter({
                            isNotHavingTheAbovePaymentPlansStatuses: true,
                        });
                        return;
                    }
                    c.insights.clearFilter('isNotHavingTheAbovePaymentPlansStatuses');
                } }))));
};
export default PaymentPlansGroup;
//# sourceMappingURL=PaymentPlansGroup.js.map